import React, { useEffect, useState } from 'react';
import { handleAmount } from '../../../../shared/extra';
import { useSelector } from '../../../../imports/generalImport';
import { Box, Typography, List, ListItem, Divider } from '../../../../imports/muiImport';
import { calculatePayment } from '../customPaymentHook';

function PaymentOrderReceipt({ isWalletAccepted }) {
  const { discount, productType, points, grossAmount, isCashbackProduct } = useSelector(
    (state) => state.ProductDetail?.allData || {}
  );
  const DENOMINATION_STORE_DATA = useSelector((state) => state?.Denominations?.allData);
  const balance = useSelector((state) => state.UserBalance.allData);

  const [paymentData, setPaymentData] = useState({
    TOTAL_VALUE: 0,
    DISCOUNT: 0,
    TOTAL_DISCOUNT: 0,
    REWARD_POINTS: points || 0,
    NET_PAY: 0,
    WALLET_PAY_AMT: 0,
    WALLET_BALANCE: balance,
  });

  const netPayCalculateHandler = (calculationResult) => {
    if (isWalletAccepted) {
      if (calculationResult.netPaymentAmt - balance > 0) {
        return calculationResult.netPaymentAmt - balance;
      } else {
        return 0;
      }
    } else {
      return calculationResult.netPaymentAmt;
    }
  };

  const walleyPayCalculateHandler = (calculationResult) => {
    if (isWalletAccepted) {
      if (calculationResult.netPaymentAmt >= balance) {
        return balance;
      } else {
        return calculationResult.netPaymentAmt;
      }
    } else {
      return 0;
    }
  };

  useEffect(() => {
    const calculationResult = calculatePayment(
      DENOMINATION_STORE_DATA,
      discount,
      isCashbackProduct
    );
    const walleyPayCalculate = walleyPayCalculateHandler(calculationResult);
    const netPayCalculate = netPayCalculateHandler(calculationResult);

    setPaymentData({
      TOTAL_VALUE: calculationResult.totalGrossAmt,
      DISCOUNT: calculationResult.discount,
      TOTAL_DISCOUNT: calculationResult.totalDiscountAmt,
      REWARD_POINTS: points || 0,
      NET_PAY: netPayCalculate,
      WALLET_BALANCE: balance,
      WALLET_PAY_AMT: walleyPayCalculate,
    });
  }, [DENOMINATION_STORE_DATA, discount, balance, points, grossAmount, isWalletAccepted]);

  return (
    <Box sx={{ px: { sm: 0, md: 0, lg: 0, xl: 1 }, height: '100%' }}>
      <Typography
        variant="body1"
        gutterBottom
        sx={{
          color: {
            xs: 'primary.main',
            sm: 'textPrimary.main',
          },
          fontSize: {
            xs: '1.2rem',
            sm: '13.5px',
            lg: '15px',
          },
          fontWeight: { xs: 700, sm: 700, lg: 700 },
          textAlign: { xs: 'center', lg: 'left' },
          mb: { xs: 1, lg: 0 },
          borderBottom: { xs: 1, lg: 0 },
          mt: { xs: 1, sm: 0, lg: 0 },
        }}
      >
        Order Review
      </Typography>

      <Box
        sx={{
          borderRadius: { xs: 1, lg: 2 },
          backgroundColor: { xs: 'backgroundPrimary.main', lg: 'secondary.light' },
          py: { xs: 0, lg: '10px' },
          px: { xs: 0, lg: '8px' },
          minHeight: { xs: '100px', lg: '204px' },
        }}
      >
        <List>
          <ListItem>
            <Typography
              variant="subtitle1"
              sx={{
                minWidth: '65%',
                fontSize: { xs: '13.5px', sm: '13.5px' },
                fontWeight: { xs: 700, sm: 700, lg: 700 },
              }}
            >
              Total Value
            </Typography>
            <Typography
              variant="subtitle1"
              sx={{
                color: { xs: 'textPrimary.main', sm: 'textPrimary.main' },
                fontWeight: { xs: 700, sm: 700, lg: 700 },
                fontSize: { xs: '13.5px', sm: '13.5px' },
                minWidth: '35%',
                textAlign: { xs: 'center', sm: 'left', lg: 'center' },
              }}
            >
              {' '}
              &#x20B9; {handleAmount(paymentData?.TOTAL_VALUE)}
            </Typography>
          </ListItem>
          <Divider component="li" />

          <ListItem
            sx={{
              justifyContent: 'space-between',
            }}
          >
            <Typography
              variant="subtitle1"
              sx={{
                minWidth: '65%',
                fontWeight: { xs: 700, sm: 700, lg: 700 },
                fontSize: { xs: '13.5px', sm: '13.5px' },
              }}
            >
              {`${productType}`}({discount || 0}%)
            </Typography>
            <Typography
              variant="subtitle1"
              sx={{
                color: { xs: 'textPrimary.main', sm: 'textPrimary.main' },
                fontWeight: { xs: 700, sm: 700, lg: 700 },
                fontSize: { xs: '13.5px', sm: '13.5px' },
                minWidth: '35%',
                textAlign: { xs: 'center', sm: 'left', lg: 'center' },
              }}
            >
              {' '}
              &#x20B9; {handleAmount(paymentData?.TOTAL_DISCOUNT || 0)}
            </Typography>
          </ListItem>
          <Divider component="li" />

          {paymentData?.REWARD_POINTS > 0 && (
            <>
              <ListItem
                sx={{
                  justifyContent: 'space-between',
                }}
              >
                <Typography
                  variant="subtitle1"
                  sx={{
                    minWidth: '65%',
                    fontWeight: { xs: 700, sm: 700, lg: 700 },
                    fontSize: { xs: '13.5px', sm: '13.5px' },
                  }}
                >
                  Reward Points
                </Typography>
                <Typography
                  variant="subtitle1"
                  sx={{
                    color: { xs: 'textPrimary.main', sm: 'textPrimary.main' },
                    fontWeight: { xs: 700, sm: 700, lg: 700 },
                    fontSize: { xs: '13.5px', sm: '13.5px' },
                    minWidth: '35%',
                    textAlign: { xs: 'center', sm: 'left', lg: 'center' },
                  }}
                >
                  {' '}
                  {handleAmount(paymentData?.REWARD_POINTS)}
                </Typography>
              </ListItem>
              <Divider component="li" />
            </>
          )}

          {isWalletAccepted && (
            <>
              <ListItem
                sx={{
                  justifyContent: 'space-between',
                }}
              >
                <Typography
                  variant="subtitle1"
                  sx={{
                    minWidth: '65%',
                    fontWeight: { xs: 700, sm: 700, lg: 700 },
                    fontSize: { xs: '13.5px', sm: '13.5px' },
                  }}
                >
                  Wallet Pay
                </Typography>
                <Typography
                  variant="subtitle1"
                  sx={{
                    color: { xs: 'textPrimary.main', sm: 'textPrimary.main' },
                    fontWeight: { xs: 700, sm: 700, lg: 700 },
                    fontSize: { xs: '13.5px', sm: '13.5px' },
                    minWidth: '35%',
                    textAlign: { xs: 'center', sm: 'left', lg: 'center' },
                  }}
                >
                  ₹ {paymentData?.WALLET_PAY_AMT}
                </Typography>
              </ListItem>
              <Divider component="li" />
            </>
          )}

          <ListItem
            sx={{
              justifyContent: 'space-between',
            }}
          >
            <Typography
              variant="subtitle1"
              sx={{
                minWidth: '65%',
                color: 'primary.main',
                fontWeight: { xs: 700, sm: 700, lg: 700 },
                fontSize: { xs: '13.5px', sm: '13.5px' },
                textTransform: 'capitalize',
              }}
            >
              Total Payout
            </Typography>
            <Typography
              variant="subtitle1"
              sx={{
                color: 'primary.main',
                fontWeight: { xs: 700, sm: 700, lg: 700 },
                fontSize: { xs: '13.5px', sm: '14.5px' },
                minWidth: '35%',
                textAlign: { xs: 'center', sm: 'left', lg: 'center' },
              }}
            >
              {' '}
              &#x20B9; {handleAmount(paymentData?.NET_PAY)}
            </Typography>
          </ListItem>
        </List>
      </Box>
    </Box>
  );
}

export default PaymentOrderReceipt;
